import React from 'react';
import './ConsentToOperate.css';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import cto_dummy_1 from '../../assets/images/cto-1.jpg';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_cto_banner from '../../assets/images/img_peso1_banner.png';
import { FaIndustry, FaFileAlt, FaShieldAlt, FaCogs, FaComments, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function ConsentToOperate() {
  const ctoBenefits = [
    {
      icon: <FaIndustry />,
      title: 'Operational Compliance',
      text: 'Ensure your business meets all legal and environmental standards during operation.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Regulatory Assurance',
      text: 'Avoid legal complications by obtaining the necessary operating permissions.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Environmental Safety',
      text: 'Demonstrate your commitment to sustainable practices.',
    },
    {
      icon: <FaCogs />,
      title: 'Smooth Operations',
      text: 'Operate your business with confidence and regulatory support.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Consultation',
      description: 'Understand the operational requirements and regulations for your industry.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Document Preparation',
      description: 'Compile and prepare all the necessary documents for the application.',
    },
    {
      icon: <FaIndustry />,
      title: 'Inspection Coordination',
      description: 'Assist in coordinating inspections with the pollution control board.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit the CTO application to the relevant authorities.',
    },
    {
      icon: <FaCertificate />,
      title: 'Approval Issuance',
      description: 'Receive the Consent to Operate and begin operations legally.',
    },
  ];

  const acts = [
    "Water (Prevention and Control of Pollution) Act, 1974",
    "Air (Prevention and Control of Pollution) Act, 1981",
    "Environment Protection Act, 1986"
  ];

  const explanation = "These acts ensure businesses operate within the legal and environmental framework, protecting natural resources and public health.";

  const checklistItems = [
    { name: 'Environmental Clearance Certificate', description: 'Provide a copy of the environmental clearance certificate.' },
    { name: 'CTE Approval', description: 'Submit the previously obtained Consent to Establish (CTE) approval.' },
    { name: 'Compliance Report', description: 'Provide a report showing compliance with pollution control measures.' },
    { name: 'Operational Plans', description: 'Detailed plans for operations, including pollution control strategies.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Consent to Operate (CTO) Services"
        subheading="Ensure smooth and lawful operations with our expert CTO services."
        ctaPrimary={{ text: "Request Consultation", link: "/contact-us" }}
        ctaSecondary={{ text: "Learn More", link: "/consent-to-operate" }}
        backgroundImage={cto_dummy_1}
      />

      <ServicesOverviewSection
        title="What is Consent to Operate (CTO)?"
        description="Consent to Operate is a mandatory approval issued by pollution control boards, allowing businesses to begin operations while adhering to environmental and regulatory guidelines."
        image={img_cto_banner}
        altText="CTO Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Consent to Operate"
        description="Discover the importance of obtaining Consent to Operate for your business."
        benefits={ctoBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Environmental Laws for Operating Businesses"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple CTO Approval Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="CTO Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
